// Weekly check-in types (15Five-inspired)

export interface CheckIn {
  id: string;
  userId: string;
  weekStart: string;
  wins: string | null;
  challenges: string | null;
  mood: number | null; // 1-5
  helpNeeded: string | null;
  createdAt: string;
  updatedAt: string;
}

export interface CheckInWithUser extends CheckIn {
  user: {
    id: string;
    firstName: string;
    lastName: string;
    email: string;
  };
}

export interface CheckInInput {
  wins?: string;
  challenges?: string;
  mood?: number;
  helpNeeded?: string;
}

export const MOOD_LABELS: Record<number, string> = {
  1: 'Struggling',
  2: 'Challenging',
  3: 'Okay',
  4: 'Good',
  5: 'Great',
};

export const MOOD_EMOJIS: Record<number, string> = {
  1: '😟',
  2: '😐',
  3: '🙂',
  4: '😊',
  5: '🤩',
};
